"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextColor = getTextColor;
function getRGB(c) {
  return parseInt(c, 16) || c;
}
function getsRGB(c) {
  return getRGB(c) / 255 <= 0.03928 ? getRGB(c) / 255 / 12.92 : Math.pow((getRGB(c) / 255 + 0.055) / 1.055, 2.4);
}
function getLuminance(hexColor) {
  return 0.2126 * getsRGB(hexColor.substring(1, 3)) + 0.7152 * getsRGB(hexColor.substring(3, 5)) + 0.0722 * getsRGB(hexColor.substring(5, 7));
}
function getContrast(f, b) {
  var L1 = getLuminance(f);
  var L2 = getLuminance(b);
  return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05);
}
function getTextColor(bgColor, theme) {
  if (!bgColor) {
    return theme.sys.color.text.content.main;
  }
  var whiteContrast = getContrast(bgColor, theme.sys.color.text.content.ondark);
  var blackContrast = getContrast(bgColor, theme.sys.color.text.content.main);
  return whiteContrast > blackContrast ? theme.sys.color.text.content.ondark : theme.sys.color.text.content.main;
}